import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CardOffer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MonthlyTimer.tsx");
